<div class="flex gap-2" [formGroup]="form">
  <app-arera-ato-input-select class="my-arera-input" name="idAreraAto" [form]="form"></app-arera-ato-input-select>
  <app-arera-gestore-input-select class="my-arera-input" name="idAreraGestore" [form]="form"></app-arera-gestore-input-select>
</div>
